export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            如有版权问题、内容建议或商务合作需求，欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="rounded-2xl p-6 md:p-8 bg-background-100 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">版权反馈</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              如发现侵权内容，请发送邮件至<br />
              <span className="text-primary-600 font-medium whitespace-nowrap">copyright@fanqieys.com</span>
            </p>
          </div>

          <div className="rounded-2xl p-6 md:p-8 bg-background-100 border border-background-200/70 text-center hover:border-accent-200 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
              <i className="ri-chat-smile-2-line text-2xl text-accent-600"></i>
            </div>
            <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">内容建议</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              想看的剧找不到？告诉我们<br />
              <span className="text-accent-600 font-medium whitespace-nowrap">suggest@fanqieys.com</span>
            </p>
          </div>

          <div className="rounded-2xl p-6 md:p-8 bg-background-100 border border-background-200/70 text-center hover:border-secondary-200 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-briefcase-line text-2xl text-secondary-600"></i>
            </div>
            <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">商务合作</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              广告投放与商务洽谈<br />
              <span className="text-secondary-600 font-medium whitespace-nowrap">biz@fanqieys.com</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}